<template>
  <div class="main-container">

    <div class="toolBox">
      <div class="leftBox">
        <el-form
          :inline="true"
          :model="searchForm"
          class="searchForm"
          size="mini"
        >
          <el-form-item
            label="项目名称"
            style="margin-bottom:0"
          >
            <el-input
              v-model="searchForm.PrjName"
              placeholder="请输入项目名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="SN码"
            style="margin-bottom:0"
          >
            <el-input
              v-model="searchForm.DeviceNo"
              placeholder="请输入SN码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="操作时间"
            style="margin-bottom:0"
          >
            <el-date-picker
              v-model="searchDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-bottom:0">
            <el-button
              type="primary"
              @click="search"
            >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="table.data"
        border
        height="100%"
        stripe
        size="mini"
        style="width: 100%"
        :header-cell-style="{ background: '#2c86d1', color: 'white' ,textAlign:'center'}"
        :cell-style="{textAlign:'center'}"
        v-loading="table.loading"
      >
        <el-table-column
          prop="PrjName"
          label="项目名称"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="DeviceNo"
          label="SN码"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="DeviceName"
          label="设备名称"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="CheckUser"
          label="检测用户"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="CheckTime"
          label="检测时间"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="Status"
          label="状态"
          width="90"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.Status===1"
              type="success"
            >成功</el-tag>
            <el-tag
              v-if="scope.row.Status===0"
              type="danger"
            >失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="Result"
          label="结果信息"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="listPage admin_page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="table.pageNum"
        :page-sizes="[15,30,45]"
        :page-size="table.pageSize"
        layout="total,prev, pager, next, sizes, jumper"
        :total="table.total"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      searchType: "",
      searchDate: [],
      sumbitLoading: false,
      table: {
        data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      searchForm: {
        UserCode: null,
      },
    };
  },
  components: {},
  computed: {
    ...mapGetters(["SessionId", "UserId"]),
  },
  mounted() {
    this.getList();
  },
  methods: {
    //翻页事件
    handleSizeChange(val) {
      this.table.pageSize = val;
      if (!this.searchDate) {
        this.searchDate = [];
      }
      this.getList(this.searchForm, ...this.searchDate);
    },
    //翻页事件
    handleCurrentChange(val) {
      this.table.pageNum = val;
      if (!this.searchDate) {
        this.searchDate = [];
      }
      this.getList(this.searchForm, ...this.searchDate);
    },
    search() {
      this.table.pageNum = 1;
      this.table.pageSize = 15;
      if (!this.searchDate) {
        this.searchDate = [];
      }
      this.getList(this.searchForm, ...this.searchDate);
    },
    getList(searchForm, Stime, Etime) {
      console.log("this.searchForm", this.searchForm);
      this.table.loading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.table.pageNum,
          PageSize: this.table.pageSize,
          SearchList: [],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CheckTime",
            },
          ],
        },
      };

      if (Stime) {
        obj.Params.SearchList.push({
          CompareType: "GreaterOrEqual",
          PropertyName: "CheckTime",
          PropertyValue: Stime + " 00:00:00",
        });
      }
      if (Etime) {
        obj.Params.SearchList.push({
          CompareType: "LessOrEqual",
          PropertyName: "CheckTime",
          PropertyValue: Etime + " 23:59:59",
        });
      }
      if (searchForm) {
        Object.keys(searchForm).forEach(function (key) {
          if (searchForm[key]) {
            obj.Params.SearchList.push({
              CompareType: "Contains",
              PropertyName: key,
              PropertyValue: searchForm[key],
            });
          }
        });
      }
      return new Promise((resolve) => {
        this.$api.axios_http(this.$gd.GwAutoCheck, obj, "POST").then((res) => {
          this.table.loading = false;
          if (res.ReturnCode == 0) {
            if (res.ReturnList && res.ReturnList.length > 0) {
              res.ReturnList.forEach((item) => {
                if (item.CheckTime) {
                  item.CheckTime = this.$moment(item.CheckTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                }
              });
            }
            this.table.total = res.RecordCount;
            this.table.data = res.ReturnList;
            resolve();
          } else {
            this.$message.error(res.Error);
          }
        });
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .toolBox {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  .content {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding-top: 0;
  }
}
</style>
<style>
.el-tooltip__popper {
  font-size: 14px;
  max-width: 40%;
}
</style>
